import LOCALES from '../constants/locale-constants';

export default function generateLocalesArray() {
  const { origin, pathname } = window.location;
  const baseOrigin = origin.endsWith('.com.cn') ? origin.replace('.com.cn', '.com') : origin; // Remove ".com.cn" safely
  const routePath = pathname.split('support/partners/')[1] ? `/${pathname.split('support/partners/')[1]}` : '';
  return Object.keys(LOCALES).map((key) => {
    const locale = LOCALES[key];
    let url = `${baseOrigin}/${key}/support/partners${routePath}`;

    if (locale === 'en-US') {
      url = `${baseOrigin}/support/partners${routePath}`;
    } else if (locale === 'zh-CN') {
      url = `${baseOrigin}.cn/support/partners${routePath}`; // Append .cn for China
    }

    return { locale, url };
  });
}
